import { render, staticRenderFns } from "./TextTitle.vue?vue&type=template&id=b7346cec&scoped=true&"
import script from "./TextTitle.vue?vue&type=script&lang=js&"
export * from "./TextTitle.vue?vue&type=script&lang=js&"
import style0 from "./TextTitle.vue?vue&type=style&index=0&id=b7346cec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7346cec",
  null
  
)

export default component.exports